import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetPlaceOptions,
  GetPlaceResponse,
  getPlace as universalGetPlace,
} from './atlas-v2-place-places.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/atlas' };

export function getPlace(httpClient: HttpClient): GetPlaceSignature {
  return (searchId: string, options?: GetPlaceOptions) =>
    universalGetPlace(
      searchId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetPlaceSignature {
  /**
   * Once you have a search_id from a autocomplete Search, you can request more details about a particular establishment or point of interest by initiating a get place request.
   */
  (searchId: string, options?: GetPlaceOptions): Promise<
    NonNullablePaths<
      GetPlaceResponse,
      | `place.placeId`
      | `place.address.streetAddress.number`
      | `place.address.streetAddress.name`
      | `place.types`,
      5
    >
  >;
}

export {
  Address,
  AddressLocation,
  AddressStreetOneOf,
  GetPlaceOptions,
  GetPlaceRequest,
  GetPlaceResponse,
  Place,
  StreetAddress,
  Subdivision,
  SubdivisionType,
} from './atlas-v2-place-places.universal.js';
